export default __webpack_public_path__ + "static/media/PlantTank.9fc329a5.svg";